import { Component, effect, inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AuthService, RightsService } from '@copilot/shared';
import { RightType } from '@dataconnect/copilot';
import { isEmpty } from 'lodash-es';

@Component({
  selector: 'app-home',
  imports: [MatIconModule, MatButtonModule, RouterModule, MatDialogModule],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  private auth = inject(Auth);
  private rightsService = inject(RightsService);
  private router = inject(Router);
  private authService = inject(AuthService);

  constructor() {
    authState(this.auth).subscribe(user => {
      if (!user) {
        this.router.navigate(['/auth/login'], { replaceUrl: true, queryParams: { returnUrl: '/home' } } );
      }
    });

    effect(() => {
      const rights = this.rightsService.rights();
      if (!isEmpty(rights)) {
        if (this.rightsService.hasAny([RightType.ADMIN, RightType.SYSTEM_ADMIN])) {
          this.router.navigate(['/org/list'], { replaceUrl: true });
        }
        else if (this.rightsService.hasAny(RightType.INBOX_ACCESS)) {
          this.router.navigate(['/inbox'], { replaceUrl: true });
        }
      }
    });
  }

  public logout(): void {
    this.authService.signOut();
  }
}
